import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
:root,
:host {
  --size-base-unit: 0.5rem;
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to right" or "to left" need to be switched to using deg values
 * 3) Background Position From is used for reversing animation from right to left at 0%
 * 4) Background Position To is used for reversing animation from right to left at 100%
 * 5) Rotate Icon to 180deg for nav button
 * 6) Transformation size for badge left positions
 * 7) Transformation size for badge right positions
 * 8 to 18) Padding values for Input Field Type Tel
 */
[dir=rtl] {
  --rtlTranslateX: 50%; /* 1 */
  --rtlGradientToRight: 270deg; /* 2 */
  --rtlBackgroundPositionFrom: -135%; /* 3 */
  --rtlBackgroundPositionTo: 0%; /* 4 */
  --rtlRotate180: 180deg; /* 5 */
  --rtlRotate135: 135deg;
  --rtlBadgeLeft: -1.5; /* 6 */
  --rtlBadgeRight: 1.5; /* 7 */
  --rtlTelTypeInputFieldPaddingStart: calc(var(--size-base-unit) * 5); /* 8 */
  --rtlTelTypeInputFieldPaddingEnd: calc(var(--size-base-unit) * 2); /* 9 */
  --rtlTelTypeInputFieldMedPaddingStart: calc(var(--size-base-unit) * 4.5); /* 10 */
  --rtlTelTypeInputFieldMedPaddingEnd: calc(var(--size-base-unit) * 1.5); /* 11 */
  --rtlTelTypeInputFieldSmPaddingStart: calc(var(--size-base-unit) * 4); /* 12 */
  --rtlTelTypeInputFieldSmPaddingEnd: calc(var(--size-base-unit) * 1); /* 13 */
  --rtlTelTypeInputFieldCharBeforePaddingEnd: calc(var(--size-base-unit) * 3.75); /* 14 */
  --rtlTelTypeInputFieldCharAfterPaddingStart: calc(var(--size-base-unit) * 6); /* 15 */
  --rtlTelTypeInputFieldCharAfterErrPaddingStart: calc(var(--size-base-unit) * 9); /* 16 */
  --rtlTelTypeInputFieldIconAfterErrPaddingStart: calc(var(--size-base-unit) * 8); /* 17 */
  --rtlTelTypeInputFieldIconCharAfterErrPaddingStart: calc(var(--size-base-unit) * 12); /* 18 */
  --rtlDisplayNone: none;
  --rtlDisplayBlock: block;
  --rtlDrawerRightTranslateX: -100%;
  --rtlDrawerLeftTranslateX: 100%;
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
/**
 * style for text ellipsis
 */
/**
 * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
 */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */ /* ------------------------------------*\
    #GRID
\*------------------------------------ */
/**
 * 1) Grid layout for items like cards, etc.
 */
.cat-c-grid {
  display: flex;
  flex-direction: column;
  gap: calc(var(--size-base-unit) * 3);
  height: 100%;
}

/**
 * Grid with no gap in between items
 */
.cat-c-grid--gap-none {
  gap: 0;
}

/**
 * Extra Small gap grid
 * 1) Spacing between grid items is smaller than default
 */
.cat-c-grid--gap-xs {
  gap: calc(var(--size-base-unit) * 1);
}

/**
 * Small gap grid
 * 1) Spacing between grid items is smaller than default
 */
.cat-c-grid--gap-sm {
  gap: calc(var(--size-base-unit) * 2);
}

/**
 * Large gap grid
 * 1) Spacing between grid items is larger than default
 */
.cat-c-grid--gap-lg {
  gap: calc(var(--size-base-unit) * 4);
}

/**
 * Side by Side Grid
 * 1) Grid that stays 2 items per row on all screen sizes
 */
.cat-c-grid--side-by-side {
  flex-flow: row wrap;
}

/**
 * 2up grid
 * 1) Stacked items on small screens to 2 items per row on medium/large screens
 */
.cat-c-grid--2up {
  /**
  * 2up grid that breaks faster
  * 1) Grid that breaks from 1 to 2up at a smaller viewport than the default
  */
  /**
  * 2up grid that breaks slower
  * 1) Grid that breaks from 1 to 2up at a larger viewport than the default
  */
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2up {
    flex-flow: row wrap;
  }
}
@media all and (min-width: 35rem) {
  .cat-c-grid--2up.cat-c-grid--break-faster {
    flex-flow: row wrap;
  }
}
@media all and (min-width: 87.5rem) {
  .cat-c-grid--2up.cat-c-grid--break-slower {
    flex-flow: row wrap;
  }
}

/**
 * 2-3up grid
 * 1) 2 items per row breaks to 3 items per row on medium and large screens
 */
.cat-c-grid--2-3up {
  flex-flow: row wrap;
}

/**
 * 3up grid
 * 1) Stacked items on small screens to 3 items per row on medium/large screens
 */
@media all and (min-width: 48rem) {
  .cat-c-grid--3up {
    flex-flow: row wrap;
  }
}

/**
 * 1 to 3up grid
 * 1) Stacked items on small screens to 3 items per row on medium/large screens
 */
.cat-c-grid--1-3up {
  /**
  * 1 to 3 up grid that breaks faster
  * 1) Grid that breaks from 1 to 3up at a smaller viewport than the default
  */
  /**
  * 1 to 3up grid that breaks slower
  * 1) Grid that breaks from 1 to 3up at a larger viewport than the default
  */
  /**
  * 1 to 3up staggered grid
  * 1) Stacked items on small screens to 3 staggered items per row on medium/large screens
  */
}
@media all and (min-width: 60rem) {
  .cat-c-grid--1-3up {
    flex-flow: row wrap;
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--1-3up.cat-c-grid--break-faster {
    flex-flow: row wrap;
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--1-3up.cat-c-grid--break-slower {
    flex-direction: column;
  }
}
@media all and (min-width: 75rem) {
  .cat-c-grid--1-3up.cat-c-grid--break-slower {
    flex-flow: row wrap;
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--1-3up.cat-c-grid--staggered ::slotted(cat-grid-item:nth-child(2n)) {
    margin-block-start: calc(var(--size-base-unit) * 14.5);
  }
  .cat-c-grid--1-3up.cat-c-grid--staggered ::slotted(cat-grid-item:nth-child(3n)) {
    margin-block-start: calc(var(--size-base-unit) * 29);
  }
}

/**
 * 2 to 4up grid
 * 1) 2 items per row on small/medium screens to 4 items per row on large screens
 */
.cat-c-grid--2-4up {
  flex-flow: row wrap;
}

/**
 * 2 to 3 to 4up grid
 * 1) 2 items per row on small screens, 3up on md screens, and 4 items per row on large screens
 */
.cat-c-grid--2-3-4up {
  flex-flow: row wrap;
}

/**
 * 1 to 2 to 4up grid
 * 1) Stacked items on small screens to 2 items per row on medium screens to 4 items per row on large screens
 */
@media all and (min-width: 35rem) {
  .cat-c-grid--1-2-4up {
    flex-flow: row wrap;
  }
}

/**
 * 1 to 4up grid
 * 1) Stacked items on small screens to 4 items per row on medium/large screens
 */
@media all and (min-width: 48rem) {
  .cat-c-grid--1-4up {
    flex-flow: row wrap;
  }
}

/**
 * 1 to 2 to 4up grid
 * 1) Stacked items on small screens to 2 items per row on small/medium screens to
 * 3 items per row on medium screens and 4 items per row on large screens
 */
@media all and (min-width: 35rem) {
  .cat-c-grid--4up {
    flex-flow: row wrap;
  }
}

/**
  * Slotted grid item within 4up Grid
  */
.cat-c-grid--2-4-5up {
  flex-flow: row wrap;
}

/**
 * 2 to 3 to 4 to 5up grid
 * 1)  2 items per row on small/medium screens to 3 items per row on medium screens
 * and 4 items per row on large screens and 5 up on xl screens
 */
.cat-c-grid--2-3-4-5up {
  flex-flow: row wrap;
}

/**
 * 5up grid
 * 1) Stacked items on small screens to 2 items per row on small/medium screens to
 * 3 items per row on medium screens and 4 items per row on large screens and 5 up on xl screens
 */
@media all and (min-width: 35rem) {
  .cat-c-grid--5up {
    flex-flow: row wrap;
  }
}

/**
  * Slotted grid item within 4up Grid
  */
.cat-c-grid--2-4-6up {
  flex-flow: row wrap;
}

/**
* Prevents the grid from stretching so the grid items are staggered in height
*/
.cat-c-grid--height-auto {
  height: auto;
}

/**
 * Slotted grid item
 */
::slotted(cat-grid-item) {
  display: block;
  /**
  * Slotted grid item within side by side grid
  * 1) Grid that stays 2 items per row on all screen sizes
  */
  /**
  * Slotted grid item within 2up Grid
  */
  /**
  * Slotted grid item within 2-3up Grid
  */
  /**
  * Slotted grid item within 2up break faster (small to large screens) Grid
  */
  /**
  * Slotted grid item within 2up break slower (small to large screens) Grid
  */
  /**
  * Slotted grid item within 3up Grid
  */
  /**
  * Slotted grid item within 1-3up Grid
  */
  /**
  * Slotted grid item within 1 to 3up break faster (small to large screens) grid
  */
  /**
  * Slotted grid item within 1 to 3up break faster (small to large screens) grid with separators between
  */
  /**
  * Slotted grid item within 2up break slower (small to large screens) Grid
  */
  /**
  * Slotted grid item within 2-4up Grid
  */
  /**
  * Slotted grid item within 2-3-4up Grid
  */
  /**
  * Slotted grid item within 1-2-4up Grid
  */
  /**
  * Slotted grid item within 1-2-4up Grid
  */
  /**
  * Slotted grid item within 1-4up Grid with separators
  */
  /**
  * Slotted grid item within 4up Grid
  */
  /**
  * Slotted grid item within 2-4-5up Grid
  */
  /**
  * 2 to 3 to 4 to 5up Grid
  */
  /**
  * Slotted grid item within 4up Grid
  */
  /**
  * Slotted grid item within 4up Grid
  */
}
.cat-c-grid--side-by-side > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 1.5));
}
.cat-c-grid--side-by-side.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 0));
}
.cat-c-grid--side-by-side.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 0.5));
}
.cat-c-grid--side-by-side.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 1));
}
.cat-c-grid--side-by-side.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 2));
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2up > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 1.5));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 0));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 0.5));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 1));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 2));
  }
}
.cat-c-grid--2-3up > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 1.5));
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-3up > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 2));
  }
}
.cat-c-grid--2-3up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 0));
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-3up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 0));
  }
}
.cat-c-grid--2-3up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 0.5));
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-3up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 0.66));
  }
}
.cat-c-grid--2-3up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 1));
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-3up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 1.33));
  }
}
.cat-c-grid--2-3up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 2));
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-3up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 2.66));
  }
}
@media all and (min-width: 35rem) {
  .cat-c-grid--2up.cat-c-grid--break-faster > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 1.5));
  }
}
@media all and (min-width: 35rem) {
  .cat-c-grid--2up.cat-c-grid--break-faster.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 0));
  }
}
@media all and (min-width: 35rem) {
  .cat-c-grid--2up.cat-c-grid--break-faster.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 0.5));
  }
}
@media all and (min-width: 35rem) {
  .cat-c-grid--2up.cat-c-grid--break-faster.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 1));
  }
}
@media all and (min-width: 35rem) {
  .cat-c-grid--2up.cat-c-grid--break-faster.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 2));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2up.cat-c-grid--break-slower > ::slotted(cat-grid-item) {
    width: 100%;
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2up.cat-c-grid--break-slower > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 1.5));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2up.cat-c-grid--break-slower.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: 100%;
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2up.cat-c-grid--break-slower.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 0));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2up.cat-c-grid--break-slower.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: 100%;
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2up.cat-c-grid--break-slower.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 0.5));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2up.cat-c-grid--break-slower.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: 100%;
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2up.cat-c-grid--break-slower.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 1));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2up.cat-c-grid--break-slower.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: 100%;
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2up.cat-c-grid--break-slower.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 2));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--3up > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 1.5));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--3up > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 2));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--3up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 0));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--3up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 0));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--3up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 0.5));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--3up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 0.66));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--3up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 1));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--3up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 1.33));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--3up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 2));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--3up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 2.66));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--1-3up > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 2));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--1-3up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 0));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--1-3up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 0.66));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--1-3up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 1.33));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--1-3up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 2.66));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--1-3up.cat-c-grid--break-faster > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 2));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--1-3up.cat-c-grid--break-faster.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 0));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--1-3up.cat-c-grid--break-faster.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 0.66));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--1-3up.cat-c-grid--break-faster.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 1.33));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--1-3up.cat-c-grid--break-faster.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 2.66));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--1-3up.cat-c-grid--break-faster.cat-c-grid--separators > ::slotted(cat-grid-item) {
    padding-inline-start: calc(var(--size-base-unit) * 2);
    border-inline-start: 1px solid var(--cat-grid-separators-border-color, var(--cat-theme-color-border-secondary));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--1-3up.cat-c-grid--break-slower > ::slotted(cat-grid-item) {
    width: 100%;
  }
}
@media all and (min-width: 75rem) {
  .cat-c-grid--1-3up.cat-c-grid--break-slower > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 2));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--1-3up.cat-c-grid--break-slower.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: 100%;
  }
}
@media all and (min-width: 75rem) {
  .cat-c-grid--1-3up.cat-c-grid--break-slower.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 0));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--1-3up.cat-c-grid--break-slower.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: 100%;
  }
}
@media all and (min-width: 75rem) {
  .cat-c-grid--1-3up.cat-c-grid--break-slower.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 0.66));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--1-3up.cat-c-grid--break-slower.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: 100%;
  }
}
@media all and (min-width: 75rem) {
  .cat-c-grid--1-3up.cat-c-grid--break-slower.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 1.33));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--1-3up.cat-c-grid--break-slower.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: 100%;
  }
}
@media all and (min-width: 75rem) {
  .cat-c-grid--1-3up.cat-c-grid--break-slower.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 2.66));
  }
}
.cat-c-grid--2-4up > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 1.5));
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-4up > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 2.25));
  }
}
.cat-c-grid--2-4up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 0));
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-4up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 0));
  }
}
.cat-c-grid--2-4up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 0.5));
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-4up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 0.75));
  }
}
.cat-c-grid--2-4up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 1));
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-4up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 1.5));
  }
}
.cat-c-grid--2-4up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 2));
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-4up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 3));
  }
}
.cat-c-grid--2-3-4up > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 1.5));
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-3-4up > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 2));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2-3-4up > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 2.25));
  }
}
.cat-c-grid--2-3-4up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 0));
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-3-4up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 0));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2-3-4up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 0));
  }
}
.cat-c-grid--2-3-4up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 0.5));
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-3-4up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 0.66));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2-3-4up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 0.75));
  }
}
.cat-c-grid--2-3-4up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 1));
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-3-4up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 1.33));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2-3-4up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 1.5));
  }
}
.cat-c-grid--2-3-4up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 2));
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-3-4up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 2.66));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2-3-4up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 3));
  }
}
@media all and (min-width: 35rem) {
  .cat-c-grid--1-2-4up > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 1.5));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--1-2-4up > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 2.25));
  }
}
@media all and (min-width: 35rem) {
  .cat-c-grid--1-2-4up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 0));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--1-2-4up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 0));
  }
}
@media all and (min-width: 35rem) {
  .cat-c-grid--1-2-4up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 0.5));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--1-2-4up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 0.75));
  }
}
@media all and (min-width: 35rem) {
  .cat-c-grid--1-2-4up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 1));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--1-2-4up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 1.5));
  }
}
@media all and (min-width: 35rem) {
  .cat-c-grid--1-2-4up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 2));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--1-2-4up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 3));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--1-4up > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 2.25));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--1-4up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 0));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--1-4up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 0.75));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--1-4up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 1.5));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--1-4up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 3));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--separators.cat-c-grid--1-4up > ::slotted(cat-grid-item) {
    padding-inline-start: calc(var(--size-base-unit) * 2);
    border-inline-start: 1px solid var(--cat-grid-separators-border-color, var(--cat-theme-color-border-secondary));
  }
}
@media all and (min-width: 35rem) {
  .cat-c-grid--4up > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 1.5));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--4up > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 2));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--4up > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 2.25));
  }
}
@media all and (min-width: 35rem) {
  .cat-c-grid--4up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 0.5));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--4up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 0.66));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--4up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 0.75));
  }
}
@media all and (min-width: 35rem) {
  .cat-c-grid--4up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 1));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--4up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 1.33));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--4up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 1.5));
  }
}
@media all and (min-width: 35rem) {
  .cat-c-grid--4up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 2));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--4up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 2.66));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--4up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 3));
  }
}
@media all and (min-width: 35rem) {
  .cat-c-grid--4up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 0));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--4up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 0));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--4up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 0));
  }
}
.cat-c-grid--2-4-5up > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 1.5));
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-4-5up > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 2.25));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2-4-5up > ::slotted(cat-grid-item) {
    width: calc(20% - (var(--size-base-unit) * 2.4));
  }
}
.cat-c-grid--2-4-5up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 0));
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-4-5up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 0));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2-4-5up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(20% - (var(--size-base-unit) * 0));
  }
}
.cat-c-grid--2-4-5up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 0.5));
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-4-5up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 0.75));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2-4-5up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(20% - (var(--size-base-unit) * 0.8));
  }
}
.cat-c-grid--2-4-5up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 1));
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-4-5up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 1.5));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2-4-5up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(20% - (var(--size-base-unit) * 1.6));
  }
}
.cat-c-grid--2-4-5up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 2));
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-4-5up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 3));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2-4-5up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(20% - (var(--size-base-unit) * 3.2));
  }
}
.cat-c-grid--2-3-4-5up > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 1.5));
}
@media all and (min-width: 35rem) {
  .cat-c-grid--2-3-4-5up > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 2));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-3-4-5up > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 2.25));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2-3-4-5up > ::slotted(cat-grid-item) {
    width: calc(20% - (var(--size-base-unit) * 2.4));
  }
}
.cat-c-grid--2-3-4-5up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 0));
}
@media all and (min-width: 35rem) {
  .cat-c-grid--2-3-4-5up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 0));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-3-4-5up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 0));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2-3-4-5up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(20% - (var(--size-base-unit) * 0));
  }
}
.cat-c-grid--2-3-4-5up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 0.5));
}
@media all and (min-width: 35rem) {
  .cat-c-grid--2-3-4-5up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 0.66));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-3-4-5up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 0.75));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2-3-4-5up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(20% - (var(--size-base-unit) * 0.8));
  }
}
.cat-c-grid--2-3-4-5up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 1));
}
@media all and (min-width: 35rem) {
  .cat-c-grid--2-3-4-5up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 1.33));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-3-4-5up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 1.5));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2-3-4-5up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(20% - (var(--size-base-unit) * 1.6));
  }
}
.cat-c-grid--2-3-4-5up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 2));
}
@media all and (min-width: 35rem) {
  .cat-c-grid--2-3-4-5up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 2.66));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--2-3-4-5up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 3));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2-3-4-5up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(20% - (var(--size-base-unit) * 3.2));
  }
}
@media all and (min-width: 35rem) {
  .cat-c-grid--5up > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 1.5));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--5up > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 2));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--5up > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 2.25));
  }
}
@media all and (min-width: 75rem) {
  .cat-c-grid--5up > ::slotted(cat-grid-item) {
    width: calc(20% - (var(--size-base-unit) * 2.4));
  }
}
@media all and (min-width: 35rem) {
  .cat-c-grid--5up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 0));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--5up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 0));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--5up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 0));
  }
}
@media all and (min-width: 75rem) {
  .cat-c-grid--5up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(20% - (var(--size-base-unit) * 0));
  }
}
@media all and (min-width: 35rem) {
  .cat-c-grid--5up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 0.5));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--5up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 0.66));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--5up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 0.75));
  }
}
@media all and (min-width: 75rem) {
  .cat-c-grid--5up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(20% - (var(--size-base-unit) * 0.8));
  }
}
@media all and (min-width: 35rem) {
  .cat-c-grid--5up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 1));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--5up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 1.33));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--5up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 1.5));
  }
}
@media all and (min-width: 75rem) {
  .cat-c-grid--5up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(20% - (var(--size-base-unit) * 1.6));
  }
}
@media all and (min-width: 35rem) {
  .cat-c-grid--5up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(50% - (var(--size-base-unit) * 2));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--5up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(33.3% - (var(--size-base-unit) * 2.66));
  }
}
@media all and (min-width: 60rem) {
  .cat-c-grid--5up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 3));
  }
}
@media all and (min-width: 75rem) {
  .cat-c-grid--5up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(20% - (var(--size-base-unit) * 3.2));
  }
}
.cat-c-grid--2-4-6up > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 1.5));
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2-4-6up > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 2.25));
  }
}
@media all and (min-width: 75rem) {
  .cat-c-grid--2-4-6up > ::slotted(cat-grid-item) {
    width: calc(16.66% - (var(--size-base-unit) * 2.5));
  }
}
.cat-c-grid--2-4-6up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 0));
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2-4-6up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 0));
  }
}
@media all and (min-width: 75rem) {
  .cat-c-grid--2-4-6up.cat-c-grid--gap-none > ::slotted(cat-grid-item) {
    width: calc(16.66% - (var(--size-base-unit) * 0));
  }
}
.cat-c-grid--2-4-6up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 0.5));
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2-4-6up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 0.75));
  }
}
@media all and (min-width: 75rem) {
  .cat-c-grid--2-4-6up.cat-c-grid--gap-xs > ::slotted(cat-grid-item) {
    width: calc(16.66% - (var(--size-base-unit) * 0.83));
  }
}
.cat-c-grid--2-4-6up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 1));
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2-4-6up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 1.5));
  }
}
@media all and (min-width: 75rem) {
  .cat-c-grid--2-4-6up.cat-c-grid--gap-sm > ::slotted(cat-grid-item) {
    width: calc(16.66% - (var(--size-base-unit) * 1.66));
  }
}
.cat-c-grid--2-4-6up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
  width: calc(50% - (var(--size-base-unit) * 2));
}
@media all and (min-width: 60rem) {
  .cat-c-grid--2-4-6up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(25% - (var(--size-base-unit) * 3));
  }
}
@media all and (min-width: 75rem) {
  .cat-c-grid--2-4-6up.cat-c-grid--gap-lg > ::slotted(cat-grid-item) {
    width: calc(16.66% - (var(--size-base-unit) * 3.33));
  }
}

/**
 * First slotted grid item inside grid
 */
::slotted(cat-grid-item:first-child) {
  /**
  * First slotted grid item within 1-4up grid with separators
  */
  /**
  * First slotted grid item within 1-3up grid with separators
  */
}
@media all and (min-width: 48rem) {
  .cat-c-grid--separators.cat-c-grid--1-4up > ::slotted(cat-grid-item:first-child) {
    border: none;
    padding-inline-start: 0;
  }
}
@media all and (min-width: 48rem) {
  .cat-c-grid--separators.cat-c-grid--1-3up.cat-c-grid--break-faster > ::slotted(cat-grid-item:first-child) {
    border: none;
    padding-inline-start: 0;
  }
}

/**
  * Grid break none
  * 1) Grid that does not break and uses grid gap for spacing
  */
.cat-c-grid--break-none {
  flex-wrap: nowrap;
  margin: 0;
  grid-gap: calc(var(--size-base-unit) * 3);
}
.cat-c-grid--break-none.cat-c-grid--gap-xs {
  grid-gap: calc(var(--size-base-unit) * 1);
}
.cat-c-grid--break-none.cat-c-grid--gap-sm {
  grid-gap: calc(var(--size-base-unit) * 2);
}
.cat-c-grid--break-none.cat-c-grid--gap-lg {
  grid-gap: calc(var(--size-base-unit) * 4);
}
.cat-c-grid--break-none ::slotted(cat-grid-item) {
  padding: 0;
}
`;
       